import { ActivityTypeEnum } from '@sport-activities/sdk';

import { ToggleDefaultValueActivityTypeInterface } from './interfaces/type.config.interface';

export const ActivityCreationTypes: ToggleDefaultValueActivityTypeInterface = {
  ACTIVITY_CREATION_GROUP_LESSON_TYPE: {
    labelKey: 'activity_creation.type.form.type.collective_class.label',
    htmlValue: 'GROUP_LESSON' as ActivityTypeEnum,
  },
  ACTIVITY_CREATION_MULTI_DAY_COURSE_TYPE: {
    labelKey: 'activity_creation.type.form.type.course.label',
    htmlValue: 'MULTI_DAY_COURSE' as ActivityTypeEnum,
  },
  ACTIVITY_CREATION_EVENT_TYPE: {
    labelKey: 'activity_creation.type.form.type.event.label',
    htmlValue: 'EVENT' as ActivityTypeEnum,
  },
  ACTIVITY_CREATION_WORKSHOP_TYPE: {
    labelKey: 'activity_creation.type.form.type.workshop.label',
    htmlValue: 'WORKSHOP' as ActivityTypeEnum,
  },
  ACTIVITY_CREATION_LIVE_TYPE: {
    labelKey: 'activity_creation.type.form.type.live.label',
    htmlValue: 'LIVE' as ActivityTypeEnum,
  },
  ACTIVITY_CREATION_BIRTHDAY_TYPE: {
    labelKey: 'activity_creation.type.form.type.birthday.label',
    htmlValue: 'BIRTHDAY' as ActivityTypeEnum,
  },
  ACTIVITY_CREATION_PLAYGROUND_RENT_TYPE: {
    labelKey: 'activity_creation.type.form.type.playground_type.label',
    htmlValue: 'PLAYGROUND_RENT' as ActivityTypeEnum,
  },
  ACTIVITY_CREATION_TEST_TYPE: {
    labelKey: 'activity_creation.type.form.type.product_test.label',
    htmlValue: 'PRODUCT_TEST' as ActivityTypeEnum,
  },
};
